import { render, staticRenderFns } from "./detail-component-organisation.vue?vue&type=template&id=4755b7c6&scoped=true"
import script from "./detail-component-organisation.vue?vue&type=script&lang=ts"
export * from "./detail-component-organisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755b7c6",
  null
  
)

export default component.exports